import React from 'react';
import './Hero.css';

const Hero = () => {
  const stats = [
    { number: '10000+', label: '活跃KOL' },
    { number: '5000+', label: '合作品牌' },
    { number: <><img src={"https://qiniures.rumcn.com/image/temp/good.png"}/><img src={"https://qiniures.rumcn.com/image/temp/good.png"}/><img src={"https://qiniures.rumcn.com/image/temp/good.png"}/></>, label: '用户好评' },
  ];

  return (
    <section className="hero-section" id="home">
      <h1 className="title">俄语区海外红人营销就用东方星城</h1>
      <p className="subtitle">
          帮您高效/精准/低成本链接全俄带货红人
      </p>
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <div className="stat-number">{stat.number}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <a href={'https://mcn.rumcn.com/user/login'} target="_blank"><button className="trial-button-lg">免费试用</button></a>

      {/* 悬浮联系客服按钮 */}
      <div className="floating-customer-service">
        <button className="customer-service-btn" onClick={() => window.open('https://mcn.rumcn.com/user/login', '_blank')}>
          <div className="customer-service-icon">
            <img src="https://qiniures.rumcn.com/image/customer_white.png" alt="客服" />
          </div>
          <span className="customer-service-text">联系客服</span>
        </button>
      </div>
        
    </section>
  );
};

export default Hero; 